import { useMemo } from 'react'
import { BOOST_WEIGHT, DURATION_FACTOR } from 'config/constants/pools'
import BigNumber from 'bignumber.js'
import { useVaultPoolByKey } from 'state/pools/hooks'
import { VaultKey } from 'state/types'
import { getFullDecimalMultiplier } from '@pancakeswap/utils/getFullDecimalMultiplier'
import { BIG_ZERO } from '@pancakeswap/utils/bigNumber'

import formatSecondsToWeeks, { secondsToWeeks } from '../../utils/formatSecondsToWeeks'

export default function useAvgLockDuration(vaultKey: VaultKey | VaultKey.CakeVault) {
  const { totalLockedAmount, totalBoostedAmount } = useVaultPoolByKey(vaultKey)

  const avgLockDurationsInSeconds = useMemo(() => {
    const avgBoostRatio = totalBoostedAmount && totalLockedAmount ? totalBoostedAmount.div(totalLockedAmount) : BIG_ZERO
    return (
      Math.round(
        avgBoostRatio
          .times(new BigNumber(DURATION_FACTOR.toString()))
          .div(new BigNumber(BOOST_WEIGHT.toString()).div(getFullDecimalMultiplier(12)))
          .toNumber(),
      ) || 0
    )
  }, [totalBoostedAmount, totalLockedAmount])

  const avgLockDurationsInWeeks = useMemo(
    () => formatSecondsToWeeks(avgLockDurationsInSeconds),
    [avgLockDurationsInSeconds],
  )

  const avgLockDurationsInWeeksNum = useMemo(
    () => secondsToWeeks(avgLockDurationsInSeconds),
    [avgLockDurationsInSeconds],
  )

  return {
    avgLockDurationsInWeeks,
    avgLockDurationsInWeeksNum,
    avgLockDurationsInSeconds,
  }
}
